module.exports = __webpack_public_path__ + "static/media/spades_J.3a1d48cc.png";